import React from "react";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Checkbox from "../../../../core/CheckBox";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
import Svg from '../../../../component/Svg'

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
// import { LocalStorage } from "node-localstorage";

import Google from "../../../../assets/images/Google.svg";
import Title from "../Title";
// import Header from "../../../../component/landing-page/Header";
import { useDispatch } from "react-redux";
import { checkLogin, verifyMfa } from "../../../../store/actions/authAction";
import { apiRequest } from "../../../../services/apiService";

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import './login.css';
import AuthHeader from "../AuthHeader";

export const Login = () => {
  const navigate = useNavigate()

  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const dispatch = useDispatch()
  const [flag, setFlag] = useState(0);
  const [mfa, setMfa] = useState(null);
  const [otp, setOtp] = useState('');
  const [resending, setResending] = useState(false);
  const { isLoading, status, message } = useSelector((state) => state.authData)

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
    genratePublicToken();
  }, []);

  function viewPassword(e) {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  }

  useEffect(() => {
    //console.log('status', status)
    if (status >= 400) {
      toast.error(message || 'Unable to sign in. Please try again.');
      dispatch({ type: 'RESET_LOGIN' });
    }
  }, [status]);


  function genratePublicToken() {
    axios.get(process.env.REACT_APP_NODE_API_URL + "/auth/getPubToken", {
    }).then((response) => {
      // console.log(response.status)

      if (response.status == 200) {
        console.log("Public Token genrated..");
        //alert("public token Genrated successfully!");
      } else {
        // alert("Try Again, Error");
      }
    }).catch((error) => {
      console.log('GET PUBLIC TOKEN ERROR', error)
    });
  }

  const handleCount = e => {
    setCount(String(e.target.value).length);
  };

  const responseGoogleSuccess = (credentialResponse) => {
    const signUpData = (parseJwt(credentialResponse.credential));
    //console.log(signUpData);

    if (signUpData.email_verified === true) {

      axios.post(process.env.REACT_APP_NODE_API_URL + "/users/getUserDetails", {
        email: signUpData.email,
      }).then((response) => {
        //console.log(response.data)
        //res.redirect('/');
        if (response.data.response == 200) {
          alert("Login Sccessful!");
          window.location = '/admin/survey/list';
        } else {
          alert("User not present, please Register");
        }
      });
      // alert("successfully logined!");
    }
  }

  function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  const responseGoogleFail = (credentialResponse) => {
    alert("Google Login Failed, Try Again");
  }

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [items, setItems] = useState([]);


  //posting Login Details
  const submitLogin = async () => {
    // let options = {
    //   method: 'POST',
    //   url: process.env.REACT_APP_NODE_API_URL + "/users/checkLogin",
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json;charset=UTF-8'
    //   },
    //   data: {
    //     email: email,
    //     password: password,
    //   }
    // }
    // axios(options).then((response) => {
    //   console.log(response.data.response)
    //res.redirect('/');
    // if (response.data.response == 200) {
    //   alert("Login Sccessful!");
    //   localStorage.setItem('token_id', response.data.token_id);
    //   window.location = '/admin/survey/list';

    // } else if (response.data.response == 202) {
    //   alert("This Email Id is already present, continue to verify");
    //   // window.location = '/EmailVerification/?email=' + email;
    //   axios.get(process.env.REACT_APP_NODE_API_URL + "/users/resendRegistrationOtp?email=" + email, {
    //     // email: email,
    //   }).then((response) => {
    //     if (response.status == 200) {
    //       window.location = '/EmailVerification/?email=' + email;
    //     } else {
    //       alert("Unable to send OTP up..");
    //     }
    //   });

    // } else {
    //   alert("Unable to login, Invalid Credentials");
    // }
    // }).catch((error) => {
    //   console.log('LOGIN ERROR', error)
    // });
  };


  //==> FORM SCHEMA AND VALIDATION <==

  //Yup - Schema
  const formSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .email('This is not a valid email')
      .required('Email required')
      .test('valid-email', 'This is not a valid email', function (value) {
        if (!value) return true; // Allow empty email
        return !value.includes('/') && !value.includes('?');
      }),
    password: Yup.string().trim().required('Password required'),
  })


  //Formik - Validation
  const initialValues = {
    email: '',
    password: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema,
    onSubmit: (values) => {
      const payload = {
        email: values.email,
        password: values.password,
      }

      dispatch(checkLogin(payload, loginCallBack, setMfa))
      let f = flag + 1;
      setFlag(f);
    }
  })

  const handleChangeCopy = (e) => {
    e.preventDefault();
  };


  const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue } = formik

  const loginCallBack = (token) => {
    // navigate(`/admin/email-verification?email=${values.email}`, { state: { token } })
    localStorage.setItem('token_id', token);
    navigate('/admin/roi')
  }

  const submitMfa = (event) => {
    event.preventDefault();
    if (!/^\d{4,8}$/.test(otp)) {
      toast.error('Enter the verification code from your email.');
      return;
    }
    dispatch(verifyMfa({ user_id: mfa.user_id, otp }, loginCallBack));
  };

  const resendMfa = async () => {
    setResending(true);
    const { response, error } = await apiRequest({
      method: 'POST', url: '/users/resend-mfa', data: { user_id: mfa.user_id }
    });
    setResending(false);
    if (response?.data?.statusCode === 200) {
      toast.success(response.data.msg || 'A new code has been sent to your email.');
    } else {
      toast.error(error?.response?.data?.msg || response?.data?.msg || 'Unable to resend the code. Please try again.');
    }
  };

  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page tata-login-page'>
        <div className="auth-header">
          <div className="container">
            <div className="header-wrapper">
              <div className="logo logo-left">
                <a href="/#0t" className="home-icon"><Svg name="tata-com-logo" /></a>
              </div>
              <div className="logo logo-right">
                <a href="/#0t" className="tata-icon"><Svg name="tata-icon" /></a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <form onSubmit={mfa ? submitMfa : handleSubmit}>
                <div className="form-wrapper mb__20">
                  <div className="form-heading text-center">
                    <h3>{mfa ? 'Verify your email' : 'Welcome Back'}</h3>
                    <p>{mfa ? `Enter the verification code sent to ${mfa.email || values.email}` : 'Enter credentials to access your account'}</p>
                  </div>
                  <div className="field-wrapper">
                    {mfa ? (
                      <div className="mb__20">
                        <label htmlFor="mfa-code">Verification code</label>
                        <input
                          id="mfa-code"
                          className="form-control"
                          type="text"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          autoFocus
                          maxLength={8}
                          value={otp}
                          onChange={(event) => setOtp(event.target.value.replace(/\D/g, ''))}
                          required
                        />
                        <div className="d-flex justify-content-between mt-3">
                          <button type="button" className="btn btn-link p-0" disabled={isLoading || resending} onClick={resendMfa}>
                            {resending ? 'Sending…' : 'Resend code'}
                          </button>
                          <button type="button" className="btn btn-link p-0" disabled={isLoading || resending} onClick={() => { setMfa(null); setOtp(''); dispatch({ type: 'RESET_LOGIN' }); }}>
                            Back to login
                          </button>
                        </div>
                      </div>
                    ) : (<>
                    <div className={`mb__20 position-relative ${touched.email ? (errors.email ? 'error' : 'success') : ''}`}> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                      < Input
                        ref={inputRef}
                        type='text'
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder='Enter your work email address...'
                        clearButton={true}
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput login-input"}
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onClear={() => setFieldValue(email, '')}
                      />
                      {touched.email && errors.email && <div className="validation-msg"> {errors.email}</div>}
                    </div>
                    <div className={`mb-2 position-relative ${touched.password ? (errors.password ? 'error' : 'success') : ''}`}>{/* Add Class error to this div once error occurs and if its valid, add class success*/}
                      <Input
                        type={passwordType}
                        view="outlined"
                        color="default"
                        label=""
                        placeholder="Enter your password..."
                        fill
                        className={"formsinput login-password"}
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onCut={handleChangeCopy}
                        onCopy={handleChangeCopy}
                        onPaste={handleChangeCopy}
                      />
                      {touched.password && errors.password && <div className="validation-msg"> {errors.password}</div>}

                      <span className={"forgot-wrap " + passwordType} onClick={viewPassword}>
                        <i className="fa fa-eye " aria-hidden="true"></i>
                      </span>
                    </div>

                    <div className="additional-info d-flex justify-content-between align-items-center mb__20">
                      <Checkbox
                        type="dense"
                        color="default"
                        checked={isChecked}
                        label="Remember me"
                        onChange={() => setChecked(!isChecked)}
                        className={"formscheckbox"}
                      />
                      {/* <Link to="/admin/forgot-password">
                        <Typography
                          type="caption"
                          colorStep={60}
                          tagName="div"
                        >
                          Forgot password?
                        </Typography>
                      </Link> */}
                    </div>
                    </>)}
                  </div>
                  <div className="button-wrap">

                    <button
                      type="submit"
                      className="formsbutton roi-btn-primary btn mb-0 w-100"
                      disabled={isLoading || resending}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="white-spinner spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span className="visually-hidden">Loading...</span>
                        </>
                      ) : (
                        mfa ? "Verify and Log In" : "Log In"
                      )}
                    </button>

                    {/* GOOGLE LOGIN */}
                    {/* <div className="google-btn">
                      <GoogleLogin
                        onSuccess={responseGoogleSuccess}
                        onFailure={responseGoogleFail}
                      />
                    </div> */}
                  </div>
                  {/* CREATE ACCOUNT */}
                  <div className="form-text text-center">
                    <p>Trouble signing in? <Link to="/admin/contact-us" target="_blank">Contact us</Link></p>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
        <div className="outer-form-text text-center d-none">
          <ul className="form-menu">
            <li>
              <Link to="/admin/terms-of-use" target="_blank">Terms of Use</Link>
            </li>
            <li>
              <Link to="/admin/privacy-policy" target="_blank">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/admin/cookie-policy" target="_blank">Cookie Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Login;
